import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import FeatureBoxList from '@components/FeatureBoxList';
import MobileIcon from '@components/icons/MobileIcon';
import HomeCheckIcon from '@components/icons/HomeCheckIcon';
import CameraIcon from '@components/icons/CameraIcon';
import ShieldPersonIcon from '@components/icons/ShieldPersonIcon';
import TextBlock from '@components/TextBlock';

import './FeatureBoxSection.scss';

const featureList = [
  {
    icon: <MobileIcon />,
    description: 'home.tenant.feature-box-section-first-item'
  },
  {
    icon: <HomeCheckIcon theme="green" />,
    description: 'home.tenant.feature-box-section-second-item'
  },
  {
    icon: <CameraIcon theme="green" />,
    description: 'home.tenant.feature-box-section-third-item'
  },
  {
    icon: <ShieldPersonIcon />,
    description: 'home.tenant.feature-box-section-fourth-item'
  }
];

const renderTitle = () => (
  <TextBlock
    title={trans('home.tenant.feature-box-section-title')}
    alignTo="center"
    titleSize="big"
    contentSize="big"
    style={{ maxWidth: '700px', margin: 'auto' }}
  />
);

const FeatureBoxSection = () => (
  <section className="feature-box-section">
    {renderTitle()}
    <FeatureBoxList featureList={featureList} />
  </section>
);

export default FeatureBoxSection;
